import { useState } from "react";
import { api } from "../../api.js";
import { useResource } from "../useResource.js";
import { fillCounterparty } from "../../../../lib/primary/counterparty.js";
import { ibanGroups } from "../../../../lib/counterparties/accounts.js";

// Підтягнути реквізити за кодом: наші дані й реєстри; якщо реєстри ДПС ще не перевіряли — перевіряємо (лише читання,
// під сесією ДПС компанії; без сесії — повертаємо те, що є). → { counterparty, sources, warnings, missing, dpsCheckedAt, dpsError }
export async function lookupCounterparty(companyId, tin, { check = true } = {}) {
  const url = `/api/companies/${companyId}/primary/counterparty?tin=${tin}`;
  let r = await api(url);
  let dpsError = null;
  if (check && !r.dpsCheckedAt) {
    try { await api(`/api/companies/${companyId}/counterparties/${tin}/check`, { method: "POST" }); r = await api(url); }
    catch (e) { dpsError = e.status === 409 || /сесі|ключ/i.test(e.message) ? "реєстри ДПС не перевірено — потрібна сесія ДПС (увійдіть ключем)" : `реєстри ДПС: ${e.message}`; }
  }
  return { ...r, dpsError };
}

// Реквізити контрагента з реєстрів: що знайдено й звідки, підстановка в порожні поля, свіжа перевірка в реєстрах ДПС
// (запит під сесією ДПС компанії). Введене вами не перезаписується
const LABEL = { name: "найменування", ipn: "ІПН", address: "адреса", iban: "IBAN", bank: "банк", vatStatus: "статус ПДВ", "signer.name": "підписант", "signer.position": "посада підписанта", "signer.authority": "підстава повноважень" };
export function Autofill({ companyId, tin, current, onFill, edit }) {
  const ok = /^(\d{8}|\d{10})$/.test(tin || "");
  const [reload, setReload] = useState(0), [busy, setBusy] = useState(false), [msg, setMsg] = useState(null);
  const r = useResource(ok ? `/api/companies/${companyId}/primary/counterparty?tin=${tin}` : null, reload);
  if (!ok) return null;
  const d = r.data;
  const fields = d?.counterparty;
  const merged = fields ? fillCounterparty(current, fields) : current;
  const gains = fields ? Object.keys(LABEL).filter((k) => {
    const get = (o) => (k.startsWith("signer.") ? o?.signer?.[k.slice(7)] : o?.[k]);
    return get(fields) && !String(get(current) ?? "").trim();
  }) : [];
  const check = async () => {
    setBusy(true); setMsg(null);
    try { await api(`/api/companies/${companyId}/counterparties/${tin}/check`, { method: "POST" }); setReload((x) => x + 1); setMsg({ ok: "Реєстри ДПС перевірено" }); }
    catch (e) { setMsg({ error: e.status === 409 || /сесі/i.test(e.message) ? "Потрібна сесія ДПС — увійдіть ключем угорі сторінки" : e.message }); }
    setBusy(false);
  };
  return (
    <div className="primary-autofill" role="note">
      {r.pending ? <span className="muted small">Шукаємо реквізити в реєстрах…</span> : (
        <>
          <p className="small"><b>З реєстрів:</b>{" "}
            {d && Object.keys(d.sources || {}).length
              ? Object.entries(d.sources).map(([k, src]) => `${LABEL[k] || k} — ${src}`).join("; ")
              : "нічого не знайдено"}.
            {d?.missing?.length ? <span className="muted"> Немає в реєстрах: {d.missing.join(", ")} — вкажіть вручну.</span> : null}</p>
          {d?.warnings?.map((w) => <p key={w} className="error small">{w}</p>)}
          {edit && d?.accounts?.length > 1 && (
            <label className="field field-inline"><span>Рахунок контрагента</span>
              <select value={d.accounts.some((a) => a.iban === current.iban) ? current.iban : ""}
                onChange={(e) => { const a = d.accounts.find((x) => x.iban === e.target.value); if (a) onFill({ ...current, iban: a.iban, bank: a.bank || current.bank || "" }); }}>
                <option value="" disabled>— оберіть із збережених —</option>
                {d.accounts.map((a) => <option key={a.id} value={a.iban}>{ibanGroups(a.iban)}{a.bank ? ` · ${a.bank}` : ""}{a.isMain ? " · основний" : ""}</option>)}
              </select></label>
          )}
          {edit && <div className="primary-actions">
            {gains.length > 0 && <button type="button" className="btn btn-sm" onClick={() => onFill(merged)}>Підставити в порожні поля ({gains.map((k) => LABEL[k]).join(", ")})</button>}
            <button type="button" className="btn btn-sm btn-ghost" disabled={busy} onClick={check}>{busy ? "Перевіряємо…" : d?.dpsCheckedAt ? "Оновити з реєстрів ДПС" : "Перевірити в реєстрах ДПС"}</button>
          </div>}
          {msg && <p className={msg.error ? "error small" : "muted small"} role="status">{msg.error || msg.ok}</p>}
        </>
      )}
    </div>
  );
}
